{
	"content": {
		"declarationDetailsSection": {
			"title": "Dettagli della dichiarazione",
			"description": "Per creare la dichiarazione sono necessari il nome del cliente, l’indirizzo e il paese del titolare della dichiarazione. Le informazioni non possono essere modificate successivamente.",
			"customerLabel": "Account cliente"
		},
		"provideDeclarationsDetailsSection": {
			"title": "Fornisci i dettagli della dichiarazione",
			"alertDescription": "Le informazioni che fornisci verranno registrate in modo permanente sulla dichiarazione e non potranno essere modificate successivamente.",
			"projectLabel": "Riferimento del progetto",
			"companyNameLabel": "Nome dell’azienda",
			"streetLabel": "Via",
			"zipCodeLabel": "CAP",
			"cityLabel": "Città",
			"countryLabel": "Paese"
		}
	},
	"summary": {
		"title": "Riepilogo",
		"declarationTypeTitle": "Tipo di dichiarazione",
		"customerProjectTitle": "Progetto del cliente",
		"internalProjectOrProductTitle": "Progetto / prodotto interno",
		"projectReferenceTitle": "Riferimento del progetto",
		"materialHeaderTitle": "Materiale",
		"quantityHeaderTitle": "Quantità ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Riduzioni di carbonio allocabili ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Riduzione di carbonio non allocabile ({{unit}})"
	},
	"errorMessages": {
		"projectRequired": "Il riferimento del progetto è obbligatorio",
		"companyNameRequired": "Il nome dell’azienda è obbligatorio",
		"streetRequired": "La via è obbligatoria",
		"zipCodeRequired": "Il CAP è obbligatorio",
		"cityRequired": "La città è obbligatoria",
		"countryRequired": "Il paese è obbligatorio",
		"customerRequired": "Il cliente è obbligatorio"
	},
	"reviewDeclarationDetailsModal": {
		"title": "Rivedi il riepilogo della dichiarazione",
		"description": "Controlla i dati inseriti per verificare eventuali errori.",
		"alertDescription": "Le informazioni che hai fornito verranno registrate in modo permanente sulla dichiarazione e non potranno essere modificate successivamente.",
		"typeSectionTitle": "1. Tipo",
		"declarationTypeLabel": "Tipo di dichiarazione",
		"customerProjectTitle": "Progetto del cliente",
		"internalProjectOrProductTitle": "Progetto / prodotto interno",
		"projectReferenceLabel": "Riferimento del progetto",
		"materialSectionTitle": "2. Materiale",
		"materialHeaderTitle": "Materiale",
		"quantityHeaderTitle": "Quantità ({{unit}})",
		"totalCarbonReductionsLabel": "Riduzioni totali di carbonio ({{unit}})",
		"declarationSectionTitle": "3. Dichiarazione",
		"companyNameLabel": "Nome dell’azienda",
		"streetLabel": "Via",
		"zipCodeLabel": "CAP",
		"cityLabel": "Città",
		"countryLabel": "Paese",
		"backTitle": "Indietro",
		"submitTitle": "Sì, è tutto corretto"
	},
	"submitTitle": "Crea dichiarazione",
	"backTitle": "Indietro"
}
